<template>
    <div class="chart text-center">
        <apexchart v-if="data.series !== undefined && ready"
            ref="chart"
            class="pa-4 pt-0"
            :height="'100%'"
            :type="type ? type: 'bar'"
            :options="options"
            :series="data.series"
        ></apexchart>
        <p v-else>Loading ...</p>
    </div>
</template>

<script>
export default {
    name: 'Home',
    props: ['data', 'type', 'freq', 'defaultColors', 'showXaxis', 'ytitle'],
    data() {
        return {
            ready: false,
            months: [
                'En',
                'Feb',
                'Mar',
                'Abr',
                'May',
                'Jun',
                'Jul',
                'Ago',
                'Sept',
                'Oct',
                'Nov',
                'Dic'
            ],
            options: null,
            description: ''
        }
    },
    methods: {
        async updateOptions(){
            this.ready = false
            this.options = {
                chart: {
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: { 
                    position: 'bottom',
                    horizontalAlign: 'center',
                    height: 60
                },
                grid: {
                    show: false
                },
                stroke: {
                    curve: 'smooth',
                },
                colors: ['#008ffb', '#00e396', '#feb019'],
                yaxis: {
                    show: true,
                    title: {
                        text: ''
                    },
                    max: 100,
                    min: 0,
                    tickAmount: 10,
                    labels: {
                        show: false
                    }
                },
                xaxis: {
                    categories: [],
                    labels: {
                        show: this.showXaxis || false
                    }
                }
            }
            
            this.setYaxis()
            this.setCategories()
            this.setColors()
            
            this.ready = true
        },
        setYaxis(){
            const max_array = this.data.series.map( serie => Math.max( ...serie.data.filter( data => !isNaN(data) ) ) )
            let max_val = Math.max(...max_array)
            max_val = parseInt(max_val + 1)

            const min_array = this.data.series.map( serie => Math.min( ...serie.data.filter( data => !isNaN(data) ) ) )
            let min_val = Math.min(...min_array)
            min_val = min_val === 0 ? 0 : parseInt(min_val - 1)

            const diff = max_val - min_val
            if(diff <= 20) {
                this.options.yaxis.max = (parseInt(max_val/5) + 2) * 5
                this.options.yaxis.min = min_val === 0 ? 0 : (parseInt(min_val/5) - 1) * 5
                this.options.yaxis.tickAmount = (this.options.yaxis.max - this.options.yaxis.min) /5
            }
            else if(diff <= 200){
                this.options.yaxis.max = (parseInt(max_val/10) + 1) * 10
                this.options.yaxis.min = min_val === 0 ? 0 : (parseInt(min_val/10) - 1) * 10
                this.options.yaxis.tickAmount = (this.options.yaxis.max - this.options.yaxis.min) / 10
            }else{
                this.options.yaxis.max = (parseInt(max_val/200) + 1) * 200
                this.options.yaxis.min = min_val === 0 ? 0 : (parseInt(min_val/200) - 1) * 200
                this.options.yaxis.tickAmount = (this.options.yaxis.max - this.options.yaxis.min) / 200
            }
            this.options.yaxis.title.text = this.ytitle
        },
        setCategories(){
            if(!this.data.categories) return
            if(this.data.categories.length == 0) return
            
            this.options.xaxis.categories = this.data.categories.map( c => {
                if(this.freq === 'minutes') 
                    return c.toLocaleString()
                if(this.freq === 'hour') 
                    return `${c.getHours()}h` 
                if(this.freq === 'day') 
                    return `${c.getDate()} ${this.months[c.getMonth()]}` 
                if(this.freq === 'month') 
                    return `${this.months[c.getMonth()]}` 
            })
        },
        setColors(){
            if(this.defaultColors) return
            const colors = {
                'Con': '#feb019',
                'Net': '#008ffb',
                'Gen': '#00e396'
            }
            this.data.series.forEach((serie, index) => {
                console.log(serie)
                const type = serie.name.split('-')[1] || 'Con'
                this.options.colors[index] = colors[type]
            });
        },
        setDescriptionDate(){
            if(!this.data.categories) return
            if(this.data.categories.length == 0) return
            if(this.freq === 'minutes') 
                this.description = `24 horas` 
            if(this.freq === 'hour') 
                this.description = `${ this.data.categories[0].toLocaleDateString() }` 
            if(this.freq === 'day') 
                this.description = `${this.data.categories[0].toLocaleDateString()} - ${this.data.categories[this.data.categories.length - 1].toLocaleDateString()}` 
            if(this.freq === 'month') 
                this.description = `${this.data.categories[0].getFullYear()}`
            this.$emit('setDescription', this.description)
        }
    },
    watch: {
        'data.series'(){
            this.updateOptions()
            this.setDescriptionDate()
        },
        type(){
            this.updateOptions()
        }
    },
    mounted(){
        this.updateOptions()
        this.setDescriptionDate()
    }
};
</script>
<style scoped>
.chart {
    height: 100%;
    width: 100%;
}
</style>
